<template>
    <div style="color: #333;">
        <AwardAEO v-if="projectInfo.project_code == '2024AEO'"
            :awards="awards" :transcripts="transcripts"
            :studentName="formattedStudentName" :accountName="accountInfo.account_nameEN"
            :projectInfo="projectInfo" :showNoAwards="showNoAwards"
            @export="exportPDF" />

        <AwardEnvirothon v-else-if="projectInfo.project_code == '2025Envirothon_Asia'"
            :awards="awards" :transcripts="transcripts"
            :studentName="formattedStudentName" :accountName="accountInfo.account_nameEN"
            :projectInfo="projectInfo" :showNoAwards="showNoAwards"
            @export="exportPDF" />

        <AwardEnvirothon2026 v-else-if="projectInfo.project_code == '2026Envirothon_Asia'"
            :awards="awards" :scores="scores"
            :studentName="formattedStudentName" :accountName="accountInfo.account_nameEN"
            :projectInfo="projectInfo" :horizontalStudentCertUrl="horizontal_student_cert_url"
            :certDate="showCertDate" :applicationId="id"
            :showNoAwards="showNoAwards" :downloading="downloading"
            @export="exportPDF" />

        <AwardDefault v-else
            :awards="awards" :scores="scores"
            :studentName="formattedStudentName" :accountName="accountInfo.account_nameEN"
            :projectInfo="projectInfo" :horizontalStudentCertUrl="horizontal_student_cert_url"
            :certDate="showCertDate" :applicationId="id"
            :showNoAwards="showNoAwards" :downloading="downloading"
            @export="exportPDF" />
    </div>
</template>

<script>
import { getStudentTranscriptsByApplication, getStudentAwardsByApplication, getProjectManageByCode } from '../../api/eae'
import AwardAEO from './components/AwardAEO.vue'
import AwardEnvirothon from './components/AwardEnvirothon.vue'
import AwardEnvirothon2026 from './components/AwardEnvirothon2026.vue'
import AwardDefault from './components/AwardDefault.vue'
import {
    DOWNLOAD_REQUIRES_EXTERNAL_BROWSER,
    downloadCertificateImages
} from '../../utils/certificateImage'
import { getCertificateDownloadPrefix } from '../../config/digitalCertificates'

export default {
    name: 'index',
    components: {
        AwardAEO,
        AwardEnvirothon,
        AwardEnvirothon2026,
        AwardDefault
    },
    data() {
        return {
            showCertDate: '',
            projectManager: {},
            id: this.$route.query.id,
            awards: [],
            transcripts: [],
            projectInfo: {},
            studentInfo: {},
            accountInfo: {},
            showNoAwards: false,
            horizontal_student_cert_url: '',
            scores: [],
            downloading: false
        }
    },
    computed: {
        formattedStudentName() {
            if (!this.studentInfo.student_givenName_pinyin) return ''
            return this.upfirstName(this.studentInfo.student_givenName_pinyin) + ' ' +
                this.upfirstName(this.studentInfo.student_lastName_pinyin)
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        formatGradeInfo(grade) {
            if (grade >= 4) {
                return 'Excellence'
            }
            if (grade >= 3) {
                return 'Distinction'
            }
            if (grade >= 2) {
                return 'Great Distinction'
            }
            return 'Highest Distinction'
        },

        async fetchData() {
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });

            let awardsResult = await getStudentAwardsByApplication(this.id)
            if (awardsResult.data.code == 0) {
                this.awards = awardsResult.data.data.awards
                if (this.awards.length <= 0) {
                    this.showNoAwards = true
                }
                this.horizontal_student_cert_url = awardsResult.data.data.project_info.horizontal_student_cert
            }
            let transcriptsResult = await getStudentTranscriptsByApplication(this.id)
            let result = transcriptsResult.data.data
            this.projectInfo = result.project_info
            this.studentInfo = result.student_info
            this.accountInfo = result.account_info
            this.scores = result.scores
            if (this.projectInfo.project_code == '2024AEO') {
                if (result.scores && result.scores.length > 0) {
                    let object_exam_score = 0
                    let case_score = 0
                    let totalScore = 0
                    for (let i = 0; i < result.scores.length; i++) {
                        let score = result.scores[i]
                        totalScore += score.total_score
                        if (score.application_event == 'Objective Question Exam') {
                            object_exam_score += score.total_score
                        } else {
                            case_score += score.total_score
                        }
                    }
                    let newScore = {
                        object_exam_score: object_exam_score,
                        case_score: case_score,
                        total_score: totalScore
                    }
                    this.transcripts.push(newScore)
                }
            } else if (this.projectInfo.project_code == '2025Envirothon_Asia') {
                if (result.scores && result.scores.length > 0) {
                    let objective_score = 0
                    let presentation_score = 0
                    for (let i = 0; i < result.scores.length; i++) {
                        let score = result.scores[i]
                        if (score.mode == 'Objective Test') {
                            objective_score = score.total_score
                        } else {
                            presentation_score = score.total_score
                        }
                    }
                    let newScore = {
                        objective_score: objective_score,
                        presentation_score: presentation_score,
                    }
                    this.transcripts.push(newScore)
                }
            } else if (this.projectInfo.project_code == '2025WEC') {
                if (result.scores && result.scores.length > 0) {
                    let newScore = {
                        full_score: result.scores[0].full_score,
                        total_score: result.scores[0].total_score,
                        event_name: result.scores[0].application_event
                    }
                    this.transcripts.push(newScore)
                }
            } else {
                if (result.scores && result.scores.length > 0) {
                    for (let i = 0; i < result.scores.length; i++) {
                        let score = result.scores[i]
                        this.transcripts.push(score)
                    }
                }
            }
            let projectManageResult = await getProjectManageByCode(this.projectInfo.project_code)
            this.projectManager = projectManageResult.data
            this.formatCertDate(this.projectManager.entry_date[0].cert_date)
            loading.close()
        },

        upfirstName(name) {
            if (name == 'João Pedro') {
                return name
            }
            if (name == 'AGYEN-FREMPONG') {
                return name
            }
            return name.toLowerCase().replace(/\b([\w|']+)\b/g, function (word) {
                return word.replace(word.charAt(0), word.charAt(0).toUpperCase());
            });
        },

        async exportPDF(id) {
            const downloadPrefix = getCertificateDownloadPrefix(this.projectInfo.project_code)

            if (downloadPrefix) {
                this.downloading = true
                try {
                    const documentType = id == 'showTranscript' ? 'Transcript' : 'Certificate'
                    await downloadCertificateImages(
                        id,
                        downloadPrefix + '_' + documentType + '_' + this.formattedStudentName
                    )
                    this.$message.success(documentType + ' downloaded')
                } catch (error) {
                    console.error('Unable to download certificate image', error)
                    if (error && error.code === DOWNLOAD_REQUIRES_EXTERNAL_BROWSER) {
                        this.showOpenInBrowserMessage()
                    } else {
                        this.$message.error('Unable to download the image. Please try again.')
                    }
                } finally {
                    this.downloading = false
                }
                return
            }

            var style = document.createElement('style');
            if (id == 'showTotal') {
                if (this.projectInfo.project_code == '2026Envirothon_Asia') {
                    style.innerHTML = "@page{size:A4 portrait;margin: auto 0mm}";
                    document.getElementsByTagName("body")[0].style.zoom = 1
                } else if (this.projectInfo.project_code == '2024AEO' || this.projectInfo.project_code == '2025WEC') {
                    style.innerHTML = "@page{size:A4 landscape;margin: auto 0mm}";
                } else {
                    style.innerHTML = "@page{size:A4 landscape;margin: auto 0mm}";
                    document.getElementsByTagName("body")[0].style.zoom = 1
                }
            } else {
                if (this.projectInfo.project_code == '2024AEO') {
                    style.innerHTML = "@page{size:A4 landscape;}";
                } else {
                    style.innerHTML = "@page{size:A4 portrait;margin: auto 0mm}";
                    document.getElementsByTagName("body")[0].style.zoom = 1
                }
            }
            window.document.head.appendChild(style)
            const printData = document.getElementById(id).innerHTML
            this.PageSetup_Null();
            window.document.body.innerHTML = printData
            window.print()
        },

        showOpenInBrowserMessage() {
            this.$alert(
                'Please open this page in Safari, Chrome, Edge, or another browser to download the image.',
                'Open in a browser',
                {
                    confirmButtonText: 'OK',
                    type: 'info'
                }
            ).catch(() => {})
        },

        PageSetup_Null() {
            var HKEY_Root, HKEY_Path, HKEY_Key;
            HKEY_Root = "HKEY_CURRENT_USER";
            HKEY_Path = "\\Software\\Microsoft\\Internet Explorer\\PageSetup\\";
            try {
                var Wsh = new ActiveXObject("WScript.Shell");
                HKEY_Key = "header";
                Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "");
                HKEY_Key = "footer";
                Wsh.RegWrite(HKEY_Root + HKEY_Path + HKEY_Key, "");
            } catch (e) { }
        },

        formatCertDate(mills) {
            var date = new Date(mills);
            let year = date.getFullYear();
            let day = date.getDate();
            let month = date.getMonth() + 1;
            this.showCertDate =
                this.formatMonthToEng(month) + " " + day + ", " + year;
        },

        formatMonthToEng(month) {
            switch (month) {
                case 1: return "Jan.";
                case 2: return "Feb.";
                case 3: return "Mar.";
                case 4: return "Apr.";
                case 5: return "May.";
                case 6: return "Jun.";
                case 7: return "Jul.";
                case 8: return "Aug.";
                case 9: return "Sep.";
                case 10: return "Oct.";
                case 11: return "Nov.";
                case 12: return "Dec.";
            }
        },
    }
}
</script>
